import { configureStore } from "@reduxjs/toolkit";
import appReducer from "./store/reducers/app";
import userReducer from "./store/reducers/user";
import messageReducer from "./store/reducers/message";
import rapportageReducer from "./store/reducers/rapportages";
import filtersV2Reducer from "./store/reducers/filtersv2";
import jamezztable from "./store/reducers/jamezztable";
import permissionsReducer from "./store/reducers/permissions";
import translationsReducer from "./store/reducers/translations";
import { apiRoot } from "./store/api/apiRoot";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";

const legacyReducers = {
  user: userReducer,
  message: messageReducer,
  rapportage: rapportageReducer,
  jamezztable: jamezztable,
  permissions: permissionsReducer,
  translations: translationsReducer,
};

export const store = configureStore({
  reducer: {
    ...legacyReducers,
    filtersV2: filtersV2Reducer,
    app: appReducer,
    api: apiRoot.reducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(apiRoot.middleware),
});

let currentState = {
  filters: null,
};

store.subscribe(() => {
  const prevState = currentState;
  currentState = store.getState();

  const salesareaAccessRaw = localStorage.getItem("salesareaAccess") ?? `{"counter": {}, "recent": []}`;
  let salesareaAccess = { counter: {}, recent: [] };
  try {
    salesareaAccess = JSON.parse(salesareaAccessRaw);
  } catch (e) {}

  if (prevState.filtersV2 !== currentState.filtersV2 || prevState.app !== currentState.app) {
    const nowId = currentState?.filtersV2?.vestiging_id?.value;
    const prevId = prevState?.filtersV2?.vestiging_id?.value;
    const nowName = currentState?.filtersV2?.vestiging_id?.label;
    const key = `${nowId}:${nowName}`;
    if (Number.isInteger(nowId) && nowId !== prevId) {
      const counter = salesareaAccess["counter"];
      if (key in counter) {
        counter[key] += 1;
      } else {
        counter[key] = 1;
      }

      // shift register of length 5, ugly code without class
      const recent = salesareaAccess["recent"];
      const recentIdx = recent.findIndex((v) => v === key);
      if (recentIdx !== -1) {
        // if found, put to front
        recent.splice(recentIdx, 1);
        recent.unshift(key);
      } else {
        // else, put to front
        recent.unshift(key);
        if (recent.length > 5) {
          recent.pop();
          console.assert(recent.length === 5);
        }
      }
    }
    localStorage.setItem("salesareaAccess", JSON.stringify(salesareaAccess));
  }
});

window.reduxStore = store;

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
